window.jQuery = window.$ = require("jquery");
// require("jquery");
require("underscore");
require("backbone");
require("backbone.marionette");
require("backbone.radio");
require("bluebird");
require("bootstrap");
require("slick-carousel");
// require("isotope-layout/dist/isotope.pkgd");
// require("imagesloaded");
require("./renderer.ts");
require("./main.ts");
require("../utils/social.js");
require("../utils/cookies-banner.js");
